export class Telemetry {
    playbackPosition: number = 0;
    playbackPercent: number = 0;
    playbackRate:any = 0;
    duration: number = 0;
    complete:boolean = false;
    constructor(telemetry?) {
        if(telemetry){
            this.playbackPercent = telemetry.playbackPercent || 0;
            this.playbackPosition = telemetry.playbackPosition || 0;
            this.playbackRate = telemetry.playbackRate || 0;
            this.duration = telemetry.duration || 0;
            this.complete = telemetry.complete || false;
        }

    }
}
